'use strict';

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var SvgIcon = require('@mui/material/SvgIcon');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var SvgIcon__default = /*#__PURE__*/_interopDefaultLegacy(SvgIcon);

var Map = function Map(props) {
  return /*#__PURE__*/React__default["default"].createElement(SvgIcon__default["default"], _rollupPluginBabelHelpers["extends"]({
    viewBox: "0 0 270 250"
  }, props), /*#__PURE__*/React__default["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.22 163.74L22.5 181.69l111.36 55.81 113.64-56.74-36.35-17.71-77.29 38.6z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M94.63 91.2L22.5 127.44l111.36 55.81 113.64-56.74-72.21-35.16c-4.56 8.26-9.95 16.17-14.88 22.8 6.2 3.4 10.02 8.03 10.02 13.14 0 10.42-15.86 18.86-35.43 18.86s-35.43-8.45-35.43-18.86c0-5.11 3.82-9.74 10.02-13.14-4.96-6.67-10.39-14.63-14.96-22.95",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M135 67.2c-8.01 0-14.52-6.4-14.52-14.26s6.51-14.26 14.52-14.26 14.52 6.4 14.52 14.26S143.01 67.2 135 67.2m0-54.7c-22.71 0-41.19 18.14-41.19 40.44 0 27.68 36.86 68.31 38.43 70.02 1.47 1.61 4.05 1.61 5.52 0 1.57-1.72 38.43-42.35 38.43-70.02 0-22.3-18.48-40.44-41.19-40.44z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
};
Map.propTypes = SvgIcon__default["default"].propTypes;

module.exports = Map;
